<template>
  <div class="longform-container">
    <Scroller
      :threshold="0.5"
      :top="0"
      :bottom=".8"
      v-on:index="index = $event.value"
      v-on:progress="progress = $event.value"
      v-on:offset="offset = $event.value"
      v-on:activeSections="activeSections = $event.value"
    >
      <div ref="foreground">
        <div v-for="(element, sectionIndex) in content" :key="sectionIndex">
          <div v-if="element.type === 'landing'">
            <Landing :content="element" :active="isIncluded(sectionIndex, activeSections)"/>
          </div>
          <div v-if="element.type === 'title'">
            <Title :content="element.content" :active="isIncluded(sectionIndex, activeSections)"/>
          </div>
          <div v-if="element.type === 'paragraph'">
            <Paragraph :content="element" :active="isIncluded(sectionIndex, activeSections)"/>
          </div>
          <div v-if="element.type === 'image'">
            <ImageComponent
              :content="element.content"
              :active="isIncluded(sectionIndex, activeSections)"
            />
          </div>
          <div v-if="element.type === 'quote'">
            <Quote :content="element.content" :active="isIncluded(sectionIndex, activeSections)"/>
          </div>
          <div v-if="element.type === 'chart'">
            <Chart :content="element" :active="isIncluded(sectionIndex, activeSections)"/>
          </div>
          <div v-if="element.type === 'box'">
            <Box
              :content="element"
              :active="isIncluded(sectionIndex, activeSections)"
              :offset="index === sectionIndex ? offset : null"
            />
          </div>
          <div v-if="element.type === 'parallaxBox'">
            <ParallaxBox
              :content="element.content"
              :active="isIncluded(sectionIndex, activeSections)"
              :offset="index === sectionIndex ? offset : null"
            />
          </div>
          <div v-if="element.type === 'footer'">
            <Footer
              :content="element.content"
            />
          </div>
        </div>
      </div>
    </Scroller>
  </div>
</template>

<script>
import Scroller from "@/components/Scroller.vue";
import Title from "@/components/Title.vue";
import Paragraph from "@/components/Paragraph.vue";
import ImageComponent from "@/components/ImageComponent.vue";
import Quote from "@/components/Quote.vue";
import Chart from "@/components/Chart.vue";
import Box from "@/components/Box.vue";
import Landing from "@/components/Landing.vue";
import ParallaxBox from "@/components/ParallaxBox.vue";
import Footer from "@/components/Footer.vue";
import _ from "lodash";
import content_it from "@/assets/content/content_IT.json";
import content_en from "@/assets/content/content_EN.json";

export default {
  name: "LongForm",
  components: {
    Title,
    Paragraph,
    ImageComponent,
    Quote,
    Chart,
    Box,
    Landing,
    Scroller,
    ParallaxBox,
    Footer
  },
  data() {
    return {
      index: 0,
      offset: 0,
      progress: -1,
      activeSections: [],
      baseUrl: process.env.BASE_URL
    };
  },
  methods: {
    isIncluded(value, array) {
      return _.indexOf(array, value) >= 0;
    }
  },
  computed: {
    content() {
      if(process.env.VUE_APP_LANG === 'EN'){
        return content_en.sections;
      } else {
        return content_it.sections;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
</style>
